import { useCallback } from 'react';

import SettingsLazy from '@/modules/corporate/components/Settings/index.lazy';

import { getContentUrl } from '../../modules/path/utils';
import { ContentItemType, DialogsActions, SettingsProps } from '../Settings/types';

const CONFIG = [DialogsActions.VersionHistory, DialogsActions.Archive, DialogsActions.Delete];

const asyncNoop = async () => Promise.resolve(true);

type Props = Pick<SettingsProps, 'menuItems' | 'onMenuItemAction'> & {
  content: ContentItemType;
  itemHeader: string;
  onRevertSuccess?: VoidFunction;
};

function ContentEditorSettings(props: Props) {
  const { content, itemHeader, menuItems, onMenuItemAction, onRevertSuccess } = props;
  const { view: viewUrl, manage: manageUrl } = getContentUrl(content);

  const onSuccessCb = useCallback(
    async (action: DialogsActions) => {
      if (action === DialogsActions.RevertChanges) {
        onRevertSuccess?.();
      }
    },
    [onRevertSuccess],
  );

  return (
    <SettingsLazy
      allUrls={{ viewUrl, manageUrl }}
      config={CONFIG}
      item={content}
      itemHeader={itemHeader}
      menuItems={menuItems}
      onMenuItemAction={onMenuItemAction}
      onSubmit={asyncNoop}
      onSuccessCb={onSuccessCb}
    />
  );
}

export default ContentEditorSettings;
